import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../redux/context/company/selectors'
import FileUpload from '../../../../../components/FileUpload/FileUpload'

const Sonet: React.FC = () => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)

  return (
    <FileUpload
      actionUrl={`${process.env.REACT_APP_INTEGRATION_URL}/sonet/uploads/${companyId}`}
      taskRequestUrl="/sonet/tasks/{companyId}"
      uploadText={t('integrationsPage:csv-info')}
    />
  )
}

export default Sonet
